// extracted by mini-css-extract-plugin
module.exports = {"endCallButton":"VideoToolbarBottom_endCallButton__3BvvA"};